import React from 'react';
import { sectionTitle } from './estimateUi';

const roomTabBase =
  'min-w-[44px] px-3 py-2 text-sm tabular-nums border transition-colors duration-300';

export default function StepRooms({ isUA, bedrooms, bathrooms, onBedrooms, onBathrooms }) {
  const bedRange = [1, 2, 3, 4, 5, 6];
  const bathRange = [1, 2, 3, 4];

  return (
    <div className="py-10 border-b border-border/60 space-y-8">
      <div>
        <p className={sectionTitle}>{isUA ? 'Спальні' : 'Bedrooms'}</p>
        <div className="flex flex-wrap gap-2">
          {bedRange.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onBedrooms(n)}
              className={`${roomTabBase} ${
                bedrooms === n
                  ? 'border-foreground bg-foreground text-background'
                  : 'border-border text-muted-foreground hover:border-foreground hover:text-foreground'
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className={sectionTitle}>{isUA ? 'Санвузли' : 'Bathrooms'}</p>
        <div className="flex flex-wrap gap-2">
          {bathRange.map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onBathrooms(n)}
              className={`${roomTabBase} ${
                bathrooms === n
                  ? 'border-foreground bg-foreground text-background'
                  : 'border-border text-muted-foreground hover:border-foreground hover:text-foreground'
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
